import React, { useRef } from 'react';
import HashInfraLanding from '../pages/Hashinfranew/components/section1';
import CoreFeatures from '../pages/Hashinfranew/components/section4';
import FeaturesTimeline from '../pages/Hashinfranew/components/section3';
import Section4 from '../pages/Hashinfranew/components/section5';
import Section6 from '../pages/Hashinfranew/components/section6';
import PricingSection from '../pages/Hashinfranew/components/pricing';
import HeroSection from '../pages/Hashinfranew/components/footer';
import CapabilitiesSection from '../pages/Hashinfranew/components/scroll';
import { Routes, Route } from 'react-router-dom';
import Form from '../pages/Form';

const Hashinfra = () => {
  const pricingRef = useRef(null);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div>
            <HashInfraLanding pricingRef={pricingRef} />
            <FeaturesTimeline />
            <CoreFeatures />
            <Section4 />
            <Section6 />
            <div ref={pricingRef}>
              <PricingSection />
            </div>
            <CapabilitiesSection />
            <HeroSection />
          </div>
        }
      />
      <Route path="/form" element={<Form />} />
    </Routes>
  );
};

export default Hashinfra;






// import HashinfraLandingPage from "./SectionsHashInfra/sec1";
// import Section2 from "./SectionsHashInfra/sec2";
// import Section3 from "./SectionsHashInfra/sec3";
// import Section4 from "./SectionsHashInfra/sec4";
// import Section5 from "./SectionsHashInfra/sec5";
// import Section6 from "./SectionsHashInfra/sec6";
// import Section7 from "./SectionsHashInfra/sec7";
// import Section8 from "./SectionsHashInfra/sec8";
// import Section10 from "./SectionsHashInfra/sec10";

// import React from 'react'

// const Hashinfra = () => {
//   return (
//     <div>
//       <HashinfraLandingPage />
//       <Section2 />
//       <Section3 />
//       <Section4 />
//       <Section5 />
//       <Section6 />
//       <Section7 />
//       <Section10 />
//       <Section8 />
      
//     </div>
//   )
// }

// export default Hashinfra


